module.exports = __webpack_public_path__ + "/b49b75f4c9718cd4f5d40b44674242ce.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/docusign-switch/assets/logos/instacart_logo_@2x.png
 ** module id = 1547
 ** module chunks = 0
 **/